"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Form_1 = __importDefault(require("./Form"));
const Nav_1 = __importDefault(require("./Nav"));
const layout_css_1 = __importDefault(require("../../../styles/global_ui/layout.css"));
const typography_css_1 = __importDefault(require("../../../styles/global_ui/typography.css"));
const util_css_1 = __importDefault(require("../../../styles/global_ui/util.css"));
const c = {
    column: `${layout_css_1.default.flexColumn} ${layout_css_1.default.gutter30}`,
    h1: `${typography_css_1.default.h1Responsive} ${typography_css_1.default.fontWeightNormal} ${layout_css_1.default.marginTop0} ${layout_css_1.default.marginBottom0} ${layout_css_1.default.paddingBottom10} `,
};
const EditGiveaway = ({ giveaway: initGiveaway, query }) => {
    const [activeTab, setActiveTab] = (0, react_1.useState)(query || 'overview');
    const [giveaway, setGiveaway] = (0, react_1.useState)(initGiveaway);
    const pendingChanges = (0, react_1.useMemo)(() => new Set(), []);
    const handleTabChange = (view) => {
        if (!window)
            return;
        setActiveTab(view);
        const location = window.location;
        // strip away the url query params when switching tabs, this way if a header link was clicked, it doesn't transfer over to the new view.
        const url = new URL(location.origin + location.pathname);
        url.searchParams.set('view', view);
        window.history.pushState({}, '', url);
    };
    return (react_1.default.createElement("div", { className: c.column },
        react_1.default.createElement("div", { className: c.column },
            react_1.default.createElement("div", { className: `${layout_css_1.default.flexJustifySpaceBetween} ${layout_css_1.default.flexCenterItems} ${util_css_1.default.borderBottom}` },
                react_1.default.createElement("h2", { className: c.h1 }, giveaway.title),
                react_1.default.createElement("a", { href: "/admin/giveaways" }, "< Back to Giveaways")),
            react_1.default.createElement(Nav_1.default, { activeTab: activeTab, pendingChanges: pendingChanges, setActiveTabs: handleTabChange })),
        react_1.default.createElement(Form_1.default, { activeTab: activeTab, giveaway: giveaway, pendingChanges: pendingChanges, setGiveaway: setGiveaway })));
};
exports.default = EditGiveaway;
